import { configureStore, combineReducers } from "@reduxjs/toolkit";
import loadEnrollmentReducer from "../../components/lists/LoadEnrollment/LoadEnrollment.slice";
import confirmModalReducer from "../../components/confirmModal/ConfirmModal.slice";
import acquirerFormReducer from "../../components/forms/acquirer/AcquirerForm.slice";
import acquirerReducer from "../../components/lists/Acquierer/Acquirer.slice";
import merchantListSlice from "../../components/lists/MerchantAndTerminal/Merchant.slice";
import snackbarReducer from "../../components/snackbar/Snackbar.slice";
import isoEnrollmentReducer from "../../components/lists/IsoEnrollment/IsoEnrollment.slice";
import criptoWalletReducer from "../../components/wallets/CriptoWallet.slice";
import merchantAndTerminalsReducer from "../../components/forms/MerchantAndTerminals/MerchantAndTerminals.slice";
import periodicIsoReducer from "../../components/forms/periodicIso/PeriodicIso.slice";
import merchantPeriodicReportReducer from "../../components/forms/MerchantPeriodicReport/MerchantPeriodicReport.slice";
import periodicAcquirerReportReducer from "../../components/forms/PeriodicAcquirerReport/PeriodicAcquirerReport.slice";
import monthlyReportReducer from "../../components/forms/monthlyReport/MonthlyReport.slice";
import businessReportReducer from "../../components/forms/BusinessReport/BusinessReport.slice";
import modalReducer from "../../components/modal/Modal.slice";
import adminFieldReducer from "../../components/adminFields/AdminFields.slice";
import downloadFilesReducer from "../../components/downloadFiles/DownloadFiles.slice";
import billingInfoReducer from "../../components/lists/BillingInfo/BillingInfo.slice";
import billingInfoFormReducer from "../../components/forms/BillingInfo/BillingInfoForm.slice";
import billingSettingsFormReducer from "../../components/forms/BillingSettings/BillingSettingsForm.slice";
import invoicesReducer from "../../components/lists/Invoices/Invoices.slice";
import invoiceFormReducer from "../../components/forms/Invoices/InvoiceForm.slice";
import periodicBillingReportReducer from "../../components/forms/PeriodicBillingReport/PeriodicBillingReport.slice";
import currencySelectFieldReducer from "../../components/selectField/CurrencySelectField.slice";
import countrySelectFieldReducer from "../../components/selectField/CountrySelectField.slice";
import mccSelectFieldReducer from "../../components/selectField/MccSelectField.slice";
import exchangesReducer from "../../components/lists/Exchanges/Exchanges.slice";
import globalExchangesReducer from "../../components/lists/GlobalExchanges/GlobalExchanges.slice";
import transactionSearchReportReducer from "../../components/forms/TransactionSearchReport/TransactionSearchReport.slice";
import kycStatusListReducer from "../../components/lists/KycStatusList/KycStatusList.slice";

const rootReducer = combineReducers({
  loadEnrollment: loadEnrollmentReducer,
  confirmModal: confirmModalReducer,
  acquirerForm: acquirerFormReducer,
  acquirer: acquirerReducer,
  merchantList: merchantListSlice,
  snackbar: snackbarReducer,
  isoEnrollment: isoEnrollmentReducer,
  criptoWallet: criptoWalletReducer,
  merchantAndTerminals: merchantAndTerminalsReducer,
  periodicIso: periodicIsoReducer,
  merchantPeriodicReport: merchantPeriodicReportReducer,
  periodicAcquirerReport: periodicAcquirerReportReducer,
  monthlyReport: monthlyReportReducer,
  businessReport: businessReportReducer,
  modal: modalReducer,
  adminFields: adminFieldReducer,
  downloadFiles: downloadFilesReducer,
  billingInfo: billingInfoReducer,
  billingInfoForm: billingInfoFormReducer,
  billingSettingsForm: billingSettingsFormReducer,
  invoices: invoicesReducer,
  invoiceForm: invoiceFormReducer,
  periodicBillingReport: periodicBillingReportReducer,
  currencySelectField: currencySelectFieldReducer,
  countrySelectField: countrySelectFieldReducer,
  mccSelectField: mccSelectFieldReducer,
  exchanges: exchangesReducer,
  globalExchanges: globalExchangesReducer,
  transactionSearchReport: transactionSearchReportReducer,
  kycStatusList: kycStatusListReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});
